export var PAPER_UPLOAD_STATES = {
  start: 'start',
  end: 'end'
};
export var EVENT_TYPES = {
  PAGEVIEW: 'pageview',
  PAPER_UPLOAD: 'paper_upload',
  CLICKSTREAM_VIEW: 'clickstream_view',
  CLICKSTREAM_INTERACTION: 'clickstream_interaction',
  CLICKSTREAM_SUCCESS: 'clickstream_success',
  CLICKSTREAM_COMPONENT_VIEW: 'clickstream_component_view'
};
export var COMPONENT = {
  NAMES: {
    DEMO_LINK: 'check out our demo page',
    DEMO_LINK_TOOLTIP: 'see how it works demo tooltip'
  },
  TYPES: {
    BUTTON: 'button',
    COMPONENT: 'component',
    LINK: 'link'
  }
};
export var ELEMENT = {
  NAMES: {
    PAPER_UPLOAD: 'paper upload',
    PAPER_UPLOAD_RECEIVED: 'paper upload received',
    DEMO_LINK: 'check out our demo page'
  },
  TYPES: {
    BUTTON: 'button',
    LINK: 'link'
  }
};
export var INTERACTION = {
  TYPES: {
    CLICK: 'click',
    START: 'start'
  }
};
export var PAPER_UPLOAD_ID = 'paper_upload_id';
export var ALLOCATION_MAP_KEY = 'allocationMap';
export var PAGE_TYPE = 'upload lp';
export var ORIGINS = {
  DEMO_LINK_CLICK: 'demoLink-click',
  DEMO_LINK_VIEW: 'demoLink-view',
  DEMO_LINK_HOVER: 'demoLink-hover'
};